import { context, trace } from '@opentelemetry/api';
import { logger } from '@parrot-software/observability';
import { api, headers } from 'config';

import { Auth, AuthPayload, ProfileData, PromotionalLogin } from './types';

const iamLog = logger.forDomain('IAM');
const tracer = trace.getTracer('@parrot-software/observability');

export const authSignIn = async (payload: AuthPayload) => {
  const span = tracer.startSpan('IAM.login');
  const ctx = trace.setSpan(context.active(), span);

  return context.with(ctx, async () => {
    iamLog.info('Login attempt', { 'usr.email': payload.user });

    try {
      const request = await api.post<Auth>('/v1/auth/login/', payload, {
        headers: { ...headers, 'X-Product-Auth': 'CONNECT' },
      });

      iamLog.info('Login response received', {
        'usr.email': payload.user,
        'http.status_code': request.status,
      });

      return request.data;
    } catch (error) {
      iamLog.error('Login request failed', {
        'usr.email': payload.user,
        'error.kind': (error as any)?.constructor?.name || 'UnknownError',
        'error.message': (error as any)?.message,
        'error.stack': (error as any)?.stack,
        'http.status_code': (error as any)?.response?.status,
      });
      throw error;
    } finally {
      span.end();
    }
  });
};

export const authRefreshToken = async (payload: { refresh?: string }) => {
  if (!payload.refresh) return null;
  const request = await api.post<{ access: string; refresh: string }>('/v1/auth/token/refresh', payload);

  return request.data;
};

export const getPromotionalLoginRequest = async () => {
  const response = await api.get<PromotionalLogin>('/v1/promotional/login');

  return response.data;
};

export const getProfile = async () => {
  const response = await api.get<ProfileData>('/v1/auth/profile/');

  return response.data;
};
